import "../App.css";

const Home = () => {
  return (
    <section id="home" className="page-section home-section">
      <div className="titleHeader homeTitle">
        <h1>The Last Resort</h1>
      </div>
      <div className="homeGrid">
        <div className="hga home1">
          <img
            className="home-image"
            src={require("../assets/site_pictures/land_pic_7.jpg")}
            alt="Interior of our pub"
          />
        </div>
        <div className="hga home2">
          <h1>
            Your second living room<br></br>
            except with draught beer<br></br>
            (and wine, spirits, <br></br>
            snacks, vibes, disco ball etc.)<br></br>
            <br></br>Lovely Publy
          </h1>
        </div>
        <div className="hga home3">
          <h2>Pop in for a drink!</h2>
          <p>174 Heaton Road, Newcastle upon Tyne, NE6 5HP</p>
          <p>Sun - Thurs: 11:00 to 23:00</p>
          <p>Fri - Sat: 11:00 to 00:00</p>
        </div>
        <div className="hga home4">
          <img
            className="home-image"
            src={require("../assets/site_pictures/land_pic_2.jpg")}
            alt="Beer garden"
          />
        </div>
      </div>
    </section>
  );
};

export default Home;
